module.exports = __webpack_public_path__ + "img/bild1.5348aeda.jpg";